import { RefIdentifierCreateContainer } from '@/components/containers/ref-identifiers/RefIdentifierCreateContainer'

const RefIdentifierCreatePage = () => {
    return <RefIdentifierCreateContainer pageType="requests" />
}

export default RefIdentifierCreatePage
